/**
 *{
	"messageType": "alertNotification",
	"notificationId": 1645460345010,
	"notificationDetails": {"warningType":"TRADE_PLAN_WARNING","notificationType":"WARNING","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "NOT_ON_ETB_LIST",
	"statusDetails": {"htbSymbol":"XYZ"},
	"date": "2022-02-21T11:19:05.684-0500",
	"timestamp": "1645460345684"
}

 * @param {*} statusDetails 
 * @returns an object with field htbSymbol: the symbol of a tradeplan that Tradier has as not shortable
 */
export function notOnEtbListParser(statusDetails) {
  const parsedObj = {
    htbSymbol: null,
  };
  if (statusDetails) {
    parsedObj.htbSymbol = statusDetails.htbSymbol ?? null;
  }

  return parsedObj;
}
